import Home from "components/organisms/Home";
import { useParams } from "react-router-dom";

const HomePage = (props) => {
    const { tenant } = useParams();
    return (
        <div className="relative flex size-full flex-1 flex-col overflow-auto">
            <Home tenant={tenant}></Home>
        </div>
    );
};

export default HomePage;
